/* Stompies animal line-up: quick add on hover (mouse) and a bottom sheet on tap (touch).
   Adds go through Shopify's cart API and announce themselves with Horizon's cart event,
   so the header count updates and the cart drawer opens exactly as it does on the product page. */

let Events = null;
try { Events = await import('@shopify/events'); } catch (_) { /* outside Horizon: inline confirmation only */ }

const routes = (window.Theme && window.Theme.routes) || {};
const ADD_URL = routes.cart_add_url || '/cart/add';
const CART_URL = routes.cart_url || '/cart';
const touchLike = matchMedia('(hover: none), (pointer: coarse)');

async function readCart() {
  const items = document.querySelector('cart-items-component');
  if (items) {
    await customElements.whenDefined('cart-items-component');
    if (typeof items.fetchCartData === 'function') return items.fetchCartData();
  }
  const res = await fetch(CART_URL + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
  return res.json();
}

async function addToCart(variantId, source) {
  const CLE = Events && Events.CartLinesUpdateEvent;
  const deferred = CLE ? CLE.createPromise() : null;
  if (deferred) {
    source.dispatchEvent(new CLE({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: String(variantId), quantity: 1 }],
      promise: deferred.promise,
    }));
  }
  const sections = [...document.querySelectorAll('cart-items-component')]
    .map((c) => c.dataset.sectionId).filter(Boolean).join(',');
  try {
    const res = await fetch(ADD_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections }),
    });
    const data = await res.json();
    const failed = Boolean(data.status);
    if (deferred) {
      const cart = await readCart();
      deferred.resolve({
        cart: CLE.createCartFromAjaxResponse(cart),
        detail: { items: cart.items, source: 'stompies-quick-add', itemCount: 1, sections: data.sections, didError: failed },
      });
    }
    if (failed) throw new Error(data.description || data.message || 'That size couldn’t be added.');
    return { ok: true };
  } catch (error) {
    // No-op if the event was already resolved with didError above
    if (deferred) { try { deferred.reject(error); } catch (_) {} }
    return { ok: false, message: error.message || 'That size couldn’t be added. Try again.' };
  }
}

document.querySelectorAll('[data-stp-gang]').forEach((gang) => {
  const sheet = gang.querySelector('.stp-sheet');

  /* Hover quick add: one tap on a size adds that pair */
  gang.querySelectorAll('.stp-card__quick .stp-size').forEach((btn) => {
    btn.addEventListener('click', async () => {
      if (btn.dataset.state === 'adding') return;
      btn.dataset.state = 'adding';
      const label = btn.querySelector('span');
      const original = label.textContent;
      const result = await addToCart(btn.dataset.variant, btn);
      btn.dataset.state = result.ok ? 'added' : '';
      label.textContent = result.ok ? 'Added' : 'Try again';
      setTimeout(() => { btn.dataset.state = ''; label.textContent = original; }, 1800);
    });
  });

  /* Progress line under the swipe row (phones and tablets; hidden on desktop where all ten show).
     It follows the swipe, and can be dragged or arrow-keyed to scrub through the pairs, with a
     light tick each time a new pair lines up (Android), or one tick as the drag lets go (iOS,
     which only plays haptics inside a tap). Swipes on the row itself tick from stompies-haptics.js. */
  const track = gang.querySelector('.stp-gang__track');
  const thumb = gang.querySelector('.stp-gang__progress span');
  if (track && thumb) {
    const rail = thumb.parentElement;
    const cards = [...track.children];
    const names = cards.map((c) => (c.querySelector('.stp-card__name') || c).textContent.trim());
    const maxScroll = () => Math.max(0, track.scrollWidth - track.clientWidth);
    const step = () => (cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth) || 1;
    const indexNow = () => Math.min(cards.length - 1, Math.round(track.scrollLeft / step()));
    let dragging = false, lastIndex = -1, dragStartIndex = 0;

    const paint = () => {
      const max = maxScroll();
      const width = Math.max(28, rail.clientWidth * Math.min(1, track.clientWidth / (track.scrollWidth || 1)));
      const along = max > 0 ? track.scrollLeft / max : 0;
      thumb.style.width = width + 'px';
      thumb.style.transform = `translateX(${(rail.clientWidth - width) * along}px)`;
      const i = indexNow();
      if (i !== lastIndex) {
        if (dragging && lastIndex !== -1 && window.stompiesHaptic) window.stompiesHaptic('tick');
        lastIndex = i;
        rail.setAttribute('aria-valuenow', String(i + 1));
        rail.setAttribute('aria-valuetext', `${names[i]}, ${i + 1} of ${cards.length}`);
      }
    };

    const seekTo = (clientX) => {
      const r = rail.getBoundingClientRect();
      const w = thumb.offsetWidth;
      const frac = Math.min(1, Math.max(0, (clientX - r.left - w / 2) / Math.max(1, r.width - w)));
      track.scrollLeft = frac * maxScroll();
    };
    const snapToNearest = () => track.scrollTo({ left: indexNow() * step(), behavior: 'smooth' });

    rail.addEventListener('pointerdown', (e) => {
      dragging = true;
      dragStartIndex = indexNow();
      rail.setPointerCapture(e.pointerId);
      rail.classList.add('is-dragging');
      track.style.scrollSnapType = 'none';
      track.style.scrollBehavior = 'auto';
      seekTo(e.clientX);
    });
    rail.addEventListener('pointermove', (e) => { if (dragging) seekTo(e.clientX); });
    const endDrag = () => {
      if (!dragging) return;
      dragging = false;
      rail.classList.remove('is-dragging');
      track.style.scrollSnapType = '';
      track.style.scrollBehavior = '';
      snapToNearest();
      if (typeof navigator.vibrate !== 'function' && indexNow() !== dragStartIndex && window.stompiesHaptic) {
        window.stompiesHaptic('tick');
      }
    };
    rail.addEventListener('pointerup', endDrag);
    rail.addEventListener('pointercancel', endDrag);

    rail.addEventListener('keydown', (e) => {
      const keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
      let target = null;
      if (e.key in keys) target = indexNow() + keys[e.key];
      else if (e.key === 'Home') target = 0;
      else if (e.key === 'End') target = cards.length - 1;
      if (target === null) return;
      e.preventDefault();
      track.scrollTo({ left: Math.min(cards.length - 1, Math.max(0, target)) * step(), behavior: 'smooth' });
    });

    rail.setAttribute('aria-valuemin', '1');
    rail.setAttribute('aria-valuemax', String(cards.length));
    track.addEventListener('scroll', paint, { passive: true });
    addEventListener('resize', paint);
    paint();
  }

  if (!sheet) return;

  /* Tap on touch screens: open the sheet instead of leaving the page */
  const els = {
    img: sheet.querySelector('.stp-sheet__img'),
    name: sheet.querySelector('.stp-sheet__name'),
    price: sheet.querySelector('.stp-sheet__price'),
    sizes: sheet.querySelector('.stp-sheet__sizes'),
    add: sheet.querySelector('.stp-sheet__add'),
    more: sheet.querySelector('.stp-sheet__more'),
    status: sheet.querySelector('.stp-sheet__status'),
  };
  const sizeTemplate = els.sizes.querySelector('template');
  const close = () => sheet.close();

  function open(card) {
    const data = JSON.parse(card.dataset.card);
    els.img.src = data.image;
    els.img.alt = data.name + ' grip sock-shoes';
    els.name.textContent = data.name;
    els.price.textContent = data.price;
    els.more.href = data.url;
    els.status.textContent = '';
    els.status.classList.remove('stp-sheet__status--error');
    els.add.disabled = true;
    els.add.textContent = 'Choose a size';
    els.sizes.querySelectorAll('.stp-sheet__size').forEach((n) => n.remove());
    data.sizes.forEach((s) => {
      const node = sizeTemplate.content.firstElementChild.cloneNode(true);
      const input = node.querySelector('input');
      input.value = s.id;
      input.disabled = !s.available;
      input.setAttribute('aria-label', s.available ? `${s.label}, ${s.age}` : `${s.label}, sold out`);
      node.querySelector('b').textContent = s.label;
      node.querySelector('small').textContent = s.available ? s.age : 'Sold out';
      els.sizes.appendChild(node);
    });
    sheet.showModal();
  }

  els.sizes.addEventListener('change', () => {
    els.add.disabled = false;
    els.add.textContent = 'Add to basket';
  });

  els.add.addEventListener('click', async () => {
    const picked = els.sizes.querySelector('input:checked');
    if (!picked) return;
    els.add.disabled = true;
    els.add.textContent = 'Adding…';
    const result = await addToCart(picked.value, els.add);
    if (result.ok) {
      els.status.textContent = 'Added to your basket.';
      els.add.textContent = 'Added';
      // Closing hands over to Horizon, which opens the cart drawer once this dialog has closed
      setTimeout(close, Events ? 450 : 1400);
    } else {
      els.status.textContent = result.message;
      els.status.classList.add('stp-sheet__status--error');
      els.add.disabled = false;
      els.add.textContent = 'Add to basket';
    }
  });

  sheet.querySelector('.stp-sheet__close').addEventListener('click', close);
  sheet.addEventListener('click', (e) => { if (e.target === sheet) close(); });

  gang.querySelectorAll('[data-card]').forEach((card) => {
    card.querySelectorAll('[data-open]').forEach((link) => {
      link.addEventListener('click', (e) => {
        if (!touchLike.matches) return;
        e.preventDefault();
        open(card);
      });
    });
  });
});
